import { useState, useCallback } from "react";
import axiosInstance from "services/AxiosInstance";

const API_URL = "/api/v3/zonas-sociales/activos/mantenimientos/";

export const useMantenimientoActions = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const iniciarMantenimiento = useCallback(async (uuid) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post(`${API_URL}${uuid}/iniciar/`);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const completarMantenimiento = useCallback(async (uuid, data = {}) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post(`${API_URL}${uuid}/completar/`, data);
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const cancelarMantenimiento = useCallback(async (uuid, razon = "") => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axiosInstance.post(`${API_URL}${uuid}/cancelar/`, {
        observaciones_ejecucion: razon,
      });
      return response.data;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    iniciarMantenimiento,
    completarMantenimiento,
    cancelarMantenimiento,
    isLoading,
    error,
  };
};
